import React, { useRef, useState, useCallback } from 'react';
import { UrlGovImg } from '@/utils';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { EffectFade } from 'swiper';
import { useDialog } from '@/components/Dialog/index';
import miniLogo from '../../../images/mini-logo.jpg';
import './index.less';

SwiperCore.use([EffectFade]);
export default function () {
  const dom = document.documentElement;
  const rem = (dom.clientWidth / 750) * 100;
  const sliderHeight = dom.clientHeight - 5.1 * rem;
  const swiperRef = useRef();
  const [activeIndex, setActiveIndex] = useState(0);
  const setSlideHidden = useCallback(
    index => activeIndex !== index,
    [activeIndex],
  );
  const [showDialog, Dialog] = useDialog();

  return (
    <div className="slide4 slide">
      <div className="slide4-subslide">
        <Swiper
          spaceBetween={0}
          ref={swiperRef}
          onSlideChange={e => setActiveIndex(e.activeIndex)}
        >
          <SwiperSlide style={{ visibility: setSlideHidden(0) && 'hidden' }}>
            <div
              className="slide4-subslide1"
              style={{ width: 0.889 * sliderHeight, height: sliderHeight }}
            />
          </SwiperSlide>
          <SwiperSlide style={{ visibility: setSlideHidden(1) && 'hidden' }}>
            <div
              className="slide4-subslide2"
              style={{ width: 0.846 * sliderHeight, height: sliderHeight }}
            />
            <img
              className="slide4-subslide2-logo1"
              src={require('../../../images/slide4-subslide2-logo1.png')}
              alt=""
            />
            <div className="slide4-subslide2-logo2" />
          </SwiperSlide>
          <SwiperSlide style={{ visibility: setSlideHidden(2) && 'hidden' }}>
            <div
              className="slide4-subslide3"
              style={{ width: 0.8 * sliderHeight, height: sliderHeight }}
            />
            <img
              className="slide4-subslide3-logo1"
              src={require('../../../images/slide4-subslide3-logo1.png')}
              alt=""
            />
          </SwiperSlide>
        </Swiper>
        <div className="button-group">
          <button
            className={activeIndex === 0 ? 'active' : ''}
            type="button"
            aria-label="tabIndex"
            onClick={() => {
              swiperRef.current.swiper.slideTo(0);
            }}
          />
          <button
            className={activeIndex === 1 ? 'active' : ''}
            type="button"
            aria-label="tabIndex"
            onClick={() => {
              swiperRef.current.swiper.slideTo(1);
            }}
          />
          <button
            className={activeIndex === 2 ? 'active' : ''}
            type="button"
            aria-label="tabIndex"
            onClick={() => {
              swiperRef.current.swiper.slideTo(2);
            }}
          />
        </div>
      </div>
      <div className="slide4-text-wrapper">
        <img className="mini-program" src={miniLogo} alt="" />
        <div className="slide4-text">
          <p className="slide4-text-title"> 超核玩家小程序</p>
          <p className="slide4-text-deatail">
            面向单游戏进行垂直化深度私人订制，集成不同的创意玩法，助力于超核玩家在游戏内外的超然体验.
          </p>
        </div>
      </div>
      <div className="slide4-footer">
        <div className="company-detail">
          <div className="steward">
            全国官方客服
            {' '}
            <span>9509-2888</span>
            {' '}
            7*24小时
          </div>
          <div className="business">
            <a href="https://ieg.tencent.com/"> 腾讯互娱 </a>
            {' '}
            /
            {' '}
            <button type="button" onClick={showDialog}>
              联系我们
            </button>
            {' '}
            /
            {' '}
            <a href="https://game.qq.com/contract_software.shtml"> 用户协议 </a>
            /
            <a href="https://privacy.qq.com/"> 隐私政策 </a>
            {' '}
            /
            {' '}
            <a href="https://privacy.qq.com/privacy-children.htm">
              儿童隐私保护声明
            </a>
          </div>
          <div className="copyright">
            COPYRIGHT © 1998 – 2020 TENCENT. ALL RIGHTS RESERVED.
            {' '}
          </div>
        </div>
        <div className="network-supervisor">
          <div className="network-supervisor-image">
            <UrlGovImg />
          </div>
          <div className="desc">
            <p className="txt">工商网监</p>
            <p className="txt">电子标识</p>
          </div>
        </div>
      </div>
      <Dialog />
    </div>
  );
}
